import { TextField } from "@mui/material";
import { UserSelect } from "src/components/ui/UserSelect";
import { BaseUser, OrgScopedBaseUser } from "src/stores/models/user";

export const QualityEventOwnerControl = ({
  owner,
  dueDate,
  creator,
  users,
  disabled,
  onChange,
}: {
  owner: string | null | undefined;
  dueDate: string | null;
  creator: BaseUser | undefined;
  users: OrgScopedBaseUser[];
  disabled: boolean;
  onChange: (changes: {
    owner: string | null | undefined;
    dueDate: string | null;
  }) => void;
}) => {
  const responsibleUser =
    owner === null ? creator : users.find((user) => user.id === owner);
  const activeUsers = users.filter((user) =>
    user.organizationMemberships?.some((membership) => membership.activated)
  );
  return (
    <div className="[container-type:inline-size]">
      <div className="grid grid-cols-1 gap-[16px] [@container(min-width:640px)]:grid-cols-2">
        <UserSelect
          label="Responsible person"
          value={responsibleUser}
          users={activeUsers}
          emptyLabel="Select a person"
          disableClear
          disabled={disabled}
          className="min-w-0"
          onChange={(person) =>
            onChange(
              person?.id === creator?.id
                ? { owner: null, dueDate }
                : { owner: person?.id ?? undefined, dueDate }
            )
          }
        />
        <TextField
          size="small"
          type="date"
          label="Due date"
          className="min-w-0"
          value={dueDate ?? ""}
          InputLabelProps={{ shrink: true }}
          disabled={disabled}
          onChange={(event) =>
            onChange({ owner, dueDate: event.target.value || null })
          }
        />
      </div>
    </div>
  );
};
